import React, { useState, useEffect, useRef } from 'react';

import LogoRow from "../../components/LogoRow";
import ProgressionRow from '../../components/ProgressionRow';
import FormSectionTitle from '../../components/FormSectionTitle';
import OfferBox from '../../components/OfferBox';

import { ForniturePage, PersonalDataPage } from '../../i18n';
import { BottomSheet } from '../../components/BottomSheet';
import {
    BottomsheetTriggerContainer, BottomsheetTriggerTitle, BottomsheetTriggerSubTitle,
    BottomSheetHeaderText
} from "../../components/BottomSheet/style";

import { ENV_VARIABLES } from '../../envVariables';
import { SupplyTitle, AccordionContainer, SupplyTitleGas, BooleanInputWrapper, GasTypeTitle, GasTypeCardsContainer, OptionalFieldsTitle, PopupTextStyle } from './style';
import { THEME_COLORS, MEDIA_QUERIES } from '../../styles/theme';
import { Offer } from '../../components/Offer';
import { FormContainer, InputWrapper, InputWrapperHalf, InputWrapperSmall, InputWrapperMatchSmall } from '../../components/FormContainer/components';
import { TextInput } from '../../components/TextInput';
import { SUPPLY_ADDRESS_FORM_FIELD_NAMES, supplyAddressValidateSupplier } from '../../reducers/supplyAddressForm';
import { Accordion } from "../../components/Accordion";
import { TextInputHelperText } from '../../components/TextInput/TextInputHelperText';
import { InputBoolean } from '../../components/InputBoolean';
import { PDRPopup } from '../../components/Popup/PDRPopup';
import { PODPopup } from '../../components/Popup/PODPopup';
import { MUNICIPALITY_FIELDS } from '../../reducers/provinces';
import { SubmitButton } from '../../components/Buttons';
import BigButton from '../../components/BigButton';

import { ReactComponent as CookingIcon } from "../../static/images/boilingWater.svg";
import { ReactComponent as HotWaterIcon } from "../../static/images/hotWater.svg";
import { ReactComponent as HeatIcon } from "../../static/images/heater.svg";
import { ROUTES, VALIDATORS_TYPE, INPUT_TYPES, ERROR_TEXTS } from '../../utils/constants';
import { googleAutocompleteAddress } from '../../utils/googleAutocompleteAddress';
import { fieldValidator } from '../../utils/fieldValidator';
import { ChatCallContainer } from '../../components/ChatCallContainer';
import { InfoPopup } from '../ConsentsPage/InfoPopup';
import { adfSendEvent } from '../../tracking/adfSendEvent';
import { setTrackerScript } from '../../tracking/setTracker';
import { getTrackingInfoOffer } from '../../tracking/getTrackingInfoOffer';
import { getToponimoFromAddress, getFullPlaceNameFromDescription } from '../../utils/getToponimoFromAddress';
import { DataLayerContainerSupply } from "../../components/DataLayer";

export const SupplyAddressPage = props => {
    const { offer } = props;
    const [isPdrPopupOpen, setIsPdrPopupOpen] = useState(false);
    const [isPodPopupOpen, setIsPodPopupOpen] = useState(false);

    const [isInfoPopupOpen, setIsInfoPopupOpen] = useState(false);
    const [popupContent, setPopupContent] = useState({ title: '', content: '' });
    const ProductAklamioArray = ENV_VARIABLES.ProductAklamioArray
    let ChatVisible = true
    if (offer.name.includes('VIVIpartner')  || ProductAklamioArray.includes(offer.offerId))
    {
        ChatVisible = false
    }

    const addressInputRef = useRef(null);
    const residenceAddressRef = useRef(null);
    const gasAddressRef = useRef(null);
    const recapitoAddressRef = useRef(null);

    useEffect(() => {
        props.getProviders();
    }, []);

    useEffect(() => {
        if (offer.name) {
            setTrackerScript({ ...getTrackingInfoOffer(offer), trackName: 'vivigas|x|funnel|indirizzo-fornitura' });
        }
    }, [offer]);

    useEffect(() => {
        props.onChangeText(
            SUPPLY_ADDRESS_FORM_FIELD_NAMES.timeStart, parseInt(Date.now() / 1000, 10)
        );

        if (addressInputRef.current)
            googleAutocompleteAddress(
                addressInputRef,
                () => {
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.address, '');
                },
                (result) => {
                    const resultPlaceName = getToponimoFromAddress(result.address);
                    if (resultPlaceName) {
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText, resultPlaceName.description);
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode, resultPlaceName.code);
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.address, resultPlaceName.parsedAddress || '');
                    } else {
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.address, result.address || '');
                    }
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber, result.addressNumber || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality, result.municipality || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.province, result.province || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap, result.postalCode || '');
                });

        if (residenceAddressRef.current)
            googleAutocompleteAddress(
                residenceAddressRef,
                () => {
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress, '');
                },
                (result) => {
                    const resultPlaceName = getToponimoFromAddress(result.address);
                    if (resultPlaceName) {
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText, resultPlaceName.description);
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode, resultPlaceName.code);
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress, resultPlaceName.parsedAddress || '');
                    } else {
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress, result.address || '');
                    }

                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber, result.addressNumber || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality, result.municipality || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince, result.province || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap, result.postalCode || '');
                });

        if (gasAddressRef.current)
            googleAutocompleteAddress(
                gasAddressRef,
                () => {
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress, '');
                },
                (result) => {
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress, result.address || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber, result.addressNumber || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality, result.municipality || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince, result.province || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap, result.postalCode || '');
                });

        if (recapitoAddressRef.current)
            googleAutocompleteAddress(
                recapitoAddressRef,
                () => {
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress, '');
                },
                (result) => {
                    const resultPlaceName = getToponimoFromAddress(result.address);
                    if (resultPlaceName) {
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText, resultPlaceName.description);
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode, resultPlaceName.code);
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress, resultPlaceName.parsedAddress || '');
                    } else {
                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress, result.address || '');
                    }

                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber, result.addressNumber || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality, result.municipality || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince, result.province || '');
                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap, result.postalCode || '');
                });
    }, [props.offer]);

    // TODO: should be an action
    const onSelectMunicipalityOption = (option, type) => {
        switch (type) {
            case MUNICIPALITY_FIELDS.municipality: {
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality, option.comune);
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.province, option.provincia);
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap, option.cap[0]);
                break;
            }
            case MUNICIPALITY_FIELDS.residence: {
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality, option.comune);
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince, option.provincia);
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap, option.cap[0]);
                break;
            }
            case MUNICIPALITY_FIELDS.gas: {
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality, option.comune);
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince, option.provincia);
                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap, option.cap[0]);
                break;
            }
        }

        props.setMunicipality(option, type);
    }

    return (
        <React.Fragment>
            <DataLayerContainerSupply {...props} />
            <PDRPopup isOpen={isPdrPopupOpen} close={() => setIsPdrPopupOpen(false)} />
            <PODPopup isOpen={isPodPopupOpen} close={() => setIsPodPopupOpen(false)} />
            <InfoPopup
                isOpen={isInfoPopupOpen}
                closePopup={() => setIsInfoPopupOpen(false)}
                content={popupContent}
            />
            <div className="container" style={{ marginBottom: '200px' }}>

                <ChatCallContainer
                    trackerChat={() => adfSendEvent('vivigas|x|funnel|indirizzo-fornitura|click_chat')()}
                    trackerCallMeClick={() => adfSendEvent("vivigas|x|funnel|indirizzo-fornitura|click_ti_chiamiamo_noi")()}
                    callMeSubmitStartTrackName='vivigas|x|funnel|indirizzo-fornitura|click_conferma'
                    callMeSubmitSuccessTrackName="vivigas|x|funnel|indirizzo-fornitura|thankyou_richiamami"
                    isCallMeVisible={ChatVisible}
                />

                <LogoRow />

                <ProgressionRow backpath={ROUTES.personalData} step={1} />

                <div className="row">
                    <div className="col col-xl-8">

                        <FormSectionTitle
                            title={PersonalDataPage.formTitle}
                            subtitle={PersonalDataPage.formSubtitle}
                            backpath={ROUTES.personalData}
                        />

                        <FormSectionTitle
                            title={ForniturePage.formTitle}
                            subtitle={ForniturePage.formSubtitle}
                            isActive={true}
                        />

                        <FormContainer onSubmit={e => e.preventDefault()} autoComplete="off">
                            <InputWrapperSmall>
                                <TextInput
                                    labelText="Piazza*"
                                    type={INPUT_TYPES.selectEditable}
                                    value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText]}
                                    onValueChange={e => {
                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText, e);
                                        props.addressPlaceNameFilter(e);
                                    }}
                                    error={
                                        props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameTextError]
                                        || props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCodeError]
                                    }
                                    onFocus={() => {
                                        props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameTextError);
                                        props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCodeError);
                                        props.addressPlaceNameFilter(props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText]);
                                    }}
                                    options={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameOptions]}
                                    onSelectOption={option => {
                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText, option.TOP_DESCRIZIONE_BREVE);
                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode, option.TOP_TOPONIMO_COD);
                                        props.addressPlaceNameFilter('');
                                    }}
                                    onBlurValidator={() => {
                                        if (!props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText]) return;
                                        const result = getFullPlaceNameFromDescription(
                                            props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText],
                                        );
                                        if (!result) {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameTextError, 'Toponimo non valido');
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode, '');
                                        } else {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode, result.TOP_TOPONIMO_COD);
                                        }
                                    }}
                                    optionsExtractText={o => o.TOP_DESCRIZIONE_BREVE}
                                    optionsExtractKey={o => o.TOP_TOPONIMO_COD}
                                />
                            </InputWrapperSmall>
                            <InputWrapperMatchSmall hasElementsToTheRight={true}>
                                <TextInput
                                    labelText="Indirizzo*"
                                    value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.address]}
                                    onValueChange={e => {
                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.address, e);
                                        if (e.length === 0) {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameCode, '');
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameText, '');
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix, '');
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber, '');
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality, '');
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap, '');
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.province, '');
                                        }
                                    }}
                                    error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressError]}
                                    onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressError)}
                                    ref={addressInputRef}
                                    hasLeftPadding={true}
                                    validator={VALIDATORS_TYPE.noValidation}
                                />
                            </InputWrapperMatchSmall>
                            <InputWrapperHalf hasElementsToTheRight={true}>
                                <TextInput
                                    labelText="Numero civico*"
                                    value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber]}
                                    onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumber, e)}
                                    error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumberError]}
                                    onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressNumberError)}
                                    validator={VALIDATORS_TYPE.onlyNumbers}
                                />
                            </InputWrapperHalf>
                            <InputWrapperHalf>
                                <TextInput
                                    labelText="Suffisso"
                                    value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix]}
                                    onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressSuffix, e)}
                                    validator={VALIDATORS_TYPE.suffixLength}
                                />
                            </InputWrapperHalf>

                            <InputWrapper hasElementsToTheRight={true}>
                                <TextInput
                                    labelText="Comune*"
                                    value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality]}
                                    onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality, e)}
                                    error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipalityError]}
                                    onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipalityError])}
                                    options={props.provinces}
                                    onSelectOption={o => onSelectMunicipalityOption(o, MUNICIPALITY_FIELDS.municipality)}
                                    optionsExtractText={o => o.comune}
                                />
                            </InputWrapper>
                            <InputWrapperHalf hasElementsToTheRight={true}>
                                <TextInput
                                    labelText="CAP*"
                                    value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap]}
                                    onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap, e)}
                                    error={props.form.capError}
                                    onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.capError)}
                                    options={props.municipality && props.municipality.cap}
                                    onSelectOption={option => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.cap, option)}
                                    optionsExtractText={o => o}
                                    validator={VALIDATORS_TYPE.onlyNumbers}
                                />
                            </InputWrapperHalf>
                            <InputWrapperHalf>
                                <TextInput
                                    labelText="Provincia*"
                                    value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province]}
                                    onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.province, e)}
                                    error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.provinceError]}
                                    onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.provinceError)}
                                    editable={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality] && props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.municipality].length > 0}
                                    onBlurValidator={() => {
                                        if (!fieldValidator(
                                            props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.province],
                                            VALIDATORS_TYPE.isProvinceValid
                                        )) {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.provinceError, ERROR_TEXTS.validationError);
                                        }
                                    }}
                                />
                            </InputWrapperHalf>

                            {/* RESIDENZA */}
                            <BooleanInputWrapper>
                                <InputBoolean
                                    type="checkbox"
                                    isChecked={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressMatchesResidence]}
                                    onChange={() => props.onChangeText(
                                        SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressMatchesResidence,
                                        !props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressMatchesResidence])
                                    }
                                    label="L'indirizzo di fornitura corrisponde con l'indirizzo di residenza."
                                />
                            </BooleanInputWrapper>
                            <section style={{
                                display: props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressMatchesResidence] ? 'none' : 'flex',
                                width: '100%',
                                flexWrap: 'wrap'
                            }}>
                                <OptionalFieldsTitle>Indicaci l'indirizzo di residenza</OptionalFieldsTitle>
                                <InputWrapperSmall>
                                    <TextInput
                                        labelText="Piazza*"
                                        type={INPUT_TYPES.selectEditable}
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText]}
                                        onValueChange={e => {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText, e);
                                            props.addressPlaceNameFilter(e);
                                        }}
                                        error={
                                            props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameTextError]
                                            || props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCodeError]
                                        }
                                        onFocus={() => {
                                            props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameTextError);
                                            props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCodeError);
                                            props.addressPlaceNameFilter(props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText]);
                                        }}
                                        options={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameOptions]}
                                        onSelectOption={option => {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText, option.TOP_DESCRIZIONE_BREVE);
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode, option.TOP_TOPONIMO_COD);
                                            props.addressPlaceNameFilter('');
                                        }}
                                        onBlurValidator={() => {
                                            if (!props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText]) return;
                                            const result = getFullPlaceNameFromDescription(
                                                props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText],
                                            );
                                            if (!result) {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameTextError, 'Toponimo non valido');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode, '');
                                            } else {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode, result.TOP_TOPONIMO_COD);
                                            }
                                        }}
                                        optionsExtractText={o => o.TOP_DESCRIZIONE_BREVE}
                                        optionsExtractKey={o => o.TOP_TOPONIMO_COD}
                                    />
                                </InputWrapperSmall>
                                <InputWrapperMatchSmall hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Indirizzo*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress]}
                                        onValueChange={e => {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddress, e);
                                            if (e.length === 0) {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameText, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressPlaceNameCode, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressSuffix, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince, '');
                                            }
                                        }}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressError)}
                                        ref={residenceAddressRef}
                                        validator={VALIDATORS_TYPE.noValidation}
                                        hasLeftPadding={true}
                                    />
                                </InputWrapperMatchSmall>
                                <InputWrapperHalf hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Numero civico*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumber, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumberError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressNumberError)}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf>
                                    <TextInput
                                        labelText="Suffisso"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressSuffix]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceAddressSuffix, e)}
                                        validator={VALIDATORS_TYPE.suffixLength}
                                    />
                                </InputWrapperHalf>
                                <InputWrapper hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Comune*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipalityError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipalityError)}
                                        options={props.provinces}
                                        onSelectOption={o => onSelectMunicipalityOption(o, MUNICIPALITY_FIELDS.residence)}
                                        optionsExtractText={o => o.comune}
                                    />
                                </InputWrapper>
                                <InputWrapperHalf hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="CAP*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCapError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCapError)}
                                        options={props[MUNICIPALITY_FIELDS.residence] && props[MUNICIPALITY_FIELDS.residence].cap}
                                        onSelectOption={option => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceCap, option)}
                                        optionsExtractText={o => o}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf>
                                    <TextInput
                                        labelText="Provincia*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvinceError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvinceError)}
                                        editable={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality] && props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceMunicipality].length > 0}
                                        onBlurValidator={() => {
                                            if (!fieldValidator(
                                                props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvince],
                                                VALIDATORS_TYPE.isProvinceValid
                                            )) {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.residenceProvinceError, ERROR_TEXTS.validationError);
                                            }
                                        }}
                                    />
                                </InputWrapperHalf>
                            </section>

                            {/* RECAPITO */}
                            <div style={{ marginTop: '16px' }}>
                                <BooleanInputWrapper>
                                    <InputBoolean
                                        type="checkbox"
                                        isChecked={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressMatchesSupply]}
                                        onChange={() => props.onChangeText(
                                            SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressMatchesSupply,
                                            !props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressMatchesSupply])
                                        }
                                        label="L'indirizzo di recapito delle comunicazioni corrisponde con l'indirizzo di fornitura"
                                    />
                                </BooleanInputWrapper>
                            </div>
                            <section style={{
                                display: props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressMatchesSupply] ? 'none' : 'flex',
                                width: '100%',
                                flexWrap: 'wrap'
                            }}>
                                <OptionalFieldsTitle>Indicaci l'indirizzo di recapito</OptionalFieldsTitle>
                                <InputWrapperSmall>
                                    <TextInput
                                        labelText="Piazza*"
                                        type={INPUT_TYPES.selectEditable}
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText]}
                                        onValueChange={e => {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText, e);
                                            props.addressPlaceNameFilter(e);
                                        }}
                                        error={
                                            props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameTextError]
                                            || props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCodeError]
                                        }
                                        onFocus={() => {
                                            props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameTextError);
                                            props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCodeError);
                                            props.addressPlaceNameFilter(props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText]);
                                        }}
                                        options={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.addressPlaceNameOptions]}
                                        onSelectOption={option => {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText, option.TOP_DESCRIZIONE_BREVE);
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode, option.TOP_TOPONIMO_COD);
                                            props.addressPlaceNameFilter('');
                                        }}
                                        onBlurValidator={() => {
                                            if (!props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText]) return;
                                            const result = getFullPlaceNameFromDescription(
                                                props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText],
                                            );
                                            if (!result) {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameTextError, 'Toponimo non valido');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode, '');
                                            } else {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode, result.TOP_TOPONIMO_COD);
                                            }
                                        }}
                                        optionsExtractText={o => o.TOP_DESCRIZIONE_BREVE}
                                        optionsExtractKey={o => o.TOP_TOPONIMO_COD}
                                    />
                                </InputWrapperSmall>
                                <InputWrapperMatchSmall hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Indirizzo*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress]}
                                        onValueChange={e => {
                                            props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddress, e);
                                            if (e.length === 0) {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameText, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoPlaceNameCode, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoSuffix, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap, '');
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince, '');
                                            }
                                        }}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressError)}
                                        ref={recapitoAddressRef}
                                        validator={VALIDATORS_TYPE.noValidation}
                                        hasLeftPadding={true}
                                    />
                                </InputWrapperMatchSmall>
                                <InputWrapperHalf hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Numero civico*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumber, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumberError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoAddressNumberError)}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf>
                                    <TextInput
                                        labelText="Suffisso"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoSuffix]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoSuffix, e)}
                                        validator={VALIDATORS_TYPE.suffixLength}
                                    />
                                </InputWrapperHalf>
                                <InputWrapper hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="Comune*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipalityError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipalityError)}
                                        options={props.provinces}
                                        onSelectOption={o => onSelectMunicipalityOption(o, MUNICIPALITY_FIELDS.recapito)}
                                        optionsExtractText={o => o.comune}
                                    />
                                </InputWrapper>
                                <InputWrapperHalf hasElementsToTheRight={true}>
                                    <TextInput
                                        labelText="CAP*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCapError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCapError)}
                                        options={props[MUNICIPALITY_FIELDS.recapito] && props[MUNICIPALITY_FIELDS.recapito].cap}
                                        onSelectOption={option => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoCap, option)}
                                        optionsExtractText={o => o}
                                        validator={VALIDATORS_TYPE.onlyNumbers}
                                    />
                                </InputWrapperHalf>
                                <InputWrapperHalf>
                                    <TextInput
                                        labelText="Provincia*"
                                        value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince]}
                                        onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince, e)}
                                        error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvinceError]}
                                        onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvinceError)}
                                        editable={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality] && props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoMunicipality].length > 0}
                                        onBlurValidator={() => {
                                            if (!fieldValidator(
                                                props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvince],
                                                VALIDATORS_TYPE.isProvinceValid
                                            )) {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.recapitoProvinceError, ERROR_TEXTS.validationError);
                                            }
                                        }}
                                    />
                                </InputWrapperHalf>
                            </section>
                        </FormContainer>

                        {props.offer.energy.length > 0 &&
                            <React.Fragment>
                                <SupplyTitle>FORNITURA LUCE</SupplyTitle>
                                <FormContainer autoComplete="off" onSubmit={e => e.preventDefault()}>
                                    <InputWrapper hasElementsToTheRight={true}>
                                        <TextInput
                                            labelText="Attuale fornitore*"
                                            type={INPUT_TYPES.selectEditable}
                                            value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]}
                                            onValueChange={e => {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier, e);
                                                props.supplyAddressFilterEnergyList(e);
                                            }}
                                            error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplierError]}
                                            onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplierError)}
                                            options={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersList]}
                                            onSelectOption={option => {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier, option.DESCRIZIONE);
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyOptionSelectedCode, option.CODICE_PLAYER);
                                                props.supplyAddressFilterEnergyList(option.DESCRIZIONE);
                                            }}
                                            onBlurValidator={() => {
                                                if (!props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]) return;
                                                const result = supplyAddressValidateSupplier(
                                                    props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energySuppliersListGlobal],
                                                    props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplier]
                                                );
                                                if (!result) {
                                                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentEnergySupplierError, 'Fornitore non valido');
                                                } else {
                                                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyOptionSelectedCode, result.CODICE_PLAYER);
                                                }
                                            }}
                                            optionsExtractText={o => o.DESCRIZIONE}
                                            optionsExtractKey={o => o.CODICE_PLAYER}
                                        />
                                    </InputWrapper>
                                    <InputWrapper>
                                        <TextInput
                                            labelText="POD*"
                                            value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]}
                                            onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod, e.toUpperCase())}
                                            error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.podError]}
                                            onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.podError)}
                                            HelperComponent={<TextInputHelperText onClick={() => setIsPodPopupOpen(true)}>Cos'è il POD?</TextInputHelperText>}
                                            validator={VALIDATORS_TYPE.noValidation}
                                            onBlurValidator={() => {
                                                if (!props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod]) return;
                                                if (!fieldValidator(props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pod], VALIDATORS_TYPE.pod)) {
                                                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.podError, ERROR_TEXTS.podInvalid);
                                                }
                                            }}
                                        />
                                    </InputWrapper>
                                    <InputWrapper hasElementsToTheRight={true}>
                                        <TextInput
                                            labelText="Consumo annuo*"
                                            value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumption]}
                                            onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumption, e)}
                                            error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumptionError]}
                                            onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.energyConsumptionError)}
                                            HelperComponent={<TextInputHelperText onClick={() => {
                                                setPopupContent({ title: 'Consumo annuo luce', content: <PopupTextStyle>{ForniturePage.annualEnergyPopupText}</PopupTextStyle> });
                                                setIsInfoPopupOpen(true);
                                            }}>Come trovare il consumo?</TextInputHelperText>}
                                            validator={VALIDATORS_TYPE.onlyNumbers}
                                        />
                                    </InputWrapper>
                                    <InputWrapper>
                                        <TextInput
                                            labelText="Potenza impegnata*"
                                            type={INPUT_TYPES.select}
                                            value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPower]}
                                            onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPower, e)}
                                            error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPowerError]}
                                            onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPowerError)}
                                            options={props.powerList}
                                            onSelectOption={option => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentPower, option)}
                                            optionsExtractText={o => o}
                                            optionsExtractKey={o => o}
                                            HelperComponent={<TextInputHelperText onClick={() => {
                                                setPopupContent({ title: 'Potenza', content: <PopupTextStyle>{ForniturePage.powerPopupText}</PopupTextStyle> });
                                                setIsInfoPopupOpen(true);
                                            }}>Come trovare la potenza?</TextInputHelperText>}
                                            validator={VALIDATORS_TYPE.noValidation}
                                        />
                                    </InputWrapper>
                                </FormContainer>
                            </React.Fragment>
                        }

                        {props.offer.gas.length > 0 &&
                            <React.Fragment>
                                <SupplyTitleGas>FORNITURA GAS</SupplyTitleGas>
                                <FormContainer onSubmit={e => e.preventDefault()}>
                                    <InputWrapper hasElementsToTheRight={true}>
                                        <TextInput
                                            labelText="Attuale fornitore*"
                                            type={INPUT_TYPES.selectEditable}
                                            value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]}
                                            onValueChange={e => {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier, e);
                                                props.supplyAddressFilterGasList(e);
                                            }}
                                            error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplierError]}
                                            onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplierError)}
                                            options={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersList]}
                                            onSelectOption={option => {
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier, option.DESCRIZIONE)
                                                props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasOptionSelectedCode, option.CODICE_PLAYER);
                                                props.supplyAddressFilterGasList(option.DESCRIZIONE);
                                            }}
                                            onBlurValidator={() => {
                                                if (!props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]) return;
                                                const result = supplyAddressValidateSupplier(
                                                    props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSuppliersListGlobal],
                                                    props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplier]
                                                );
                                                if (!result) {
                                                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasSupplierError, 'Fornitore non valido');
                                                } else {
                                                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasOptionSelectedCode, result.CODICE_PLAYER);
                                                }
                                            }}
                                            optionsExtractText={o => o.DESCRIZIONE}
                                            optionsExtractKey={o => o.CODICE_PLAYER}
                                        />
                                    </InputWrapper>
                                    <InputWrapper>
                                        <TextInput
                                            labelText="PDR*"
                                            value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr]}
                                            onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr, e)}
                                            error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdrError]}
                                            onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdrError)}
                                            HelperComponent={<TextInputHelperText onClick={() => setIsPdrPopupOpen(true)}>Cos'è il PDR?</TextInputHelperText>}
                                            validator={VALIDATORS_TYPE.onlyNumbers}
                                            onBlurValidator={() => {
                                                if (!props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr]) return;
                                                if (!fieldValidator(props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdr], VALIDATORS_TYPE.pdr)) {
                                                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.pdrError, ERROR_TEXTS.pdrInvalid);
                                                }
                                            }}
                                        />
                                    </InputWrapper>
                                    <GasTypeTitle>Tipologia d'uso (seleziona i modi in cui utilizzerai il gas)</GasTypeTitle>
                                    <GasTypeCardsContainer>
                                        <BigButton
                                            label="Cottura Cibi"
                                            isActive={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeCooking]}
                                            onChange={() => props.onChangeText(
                                                SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeCooking,
                                                !props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeCooking]
                                            )}
                                            icon={CookingIcon}
                                            hasCheckbox={true}
                                        />

                                        <BigButton
                                            label="Acqua Calda"
                                            isActive={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHotWater]}
                                            onChange={() => props.onChangeText(
                                                SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHotWater,
                                                !props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHotWater]
                                            )}
                                            icon={HotWaterIcon}
                                            hasCheckbox={true}
                                        />
                                        <BigButton
                                            label="Riscaldamento"
                                            isActive={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHeat]}
                                            onChange={() => props.onChangeText(
                                                SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHeat,
                                                !props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasUsageTypeHeat]
                                            )}
                                            icon={HeatIcon}
                                            hasCheckbox={true}
                                        />
                                    </GasTypeCardsContainer>
                                    <InputWrapper hasElementsToTheRight={true}>
                                        <TextInput
                                            labelText="Consumo annuo gas*"
                                            value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumption]}
                                            onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumption, e)}
                                            error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumptionError]}
                                            onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.currentGasConsumptionError)}
                                            HelperComponent={<TextInputHelperText onClick={() => {
                                                setPopupContent({ title: 'Consumo annuo gas', content: <PopupTextStyle>{ForniturePage.annualGasPopupText}</PopupTextStyle> });
                                                setIsInfoPopupOpen(true);
                                            }}>Come trovare il consumo?</TextInputHelperText>}
                                            validator={VALIDATORS_TYPE.onlyNumbers}
                                        />
                                    </InputWrapper>

                                    {false && props.offer.energy.length > 0 && <InputBoolean
                                        type="checkbox"
                                        isChecked={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressGasMatchesEnergy]}
                                        onChange={() => props.onChangeText(
                                            SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressGasMatchesEnergy,
                                            !props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressGasMatchesEnergy])
                                        }
                                        label="L'indirizzo di fornitura del Gas corrisponde a quello della Luce."
                                    />}

                                    <section style={{
                                        display: props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.supplyAddressGasMatchesEnergy] ? 'none' : 'flex',
                                        width: '100%',
                                        flexWrap: 'wrap'
                                    }}>
                                        <OptionalFieldsTitle>Indicaci l'indirizzo di fornitura del gas</OptionalFieldsTitle>
                                        <InputWrapper>
                                            <TextInput
                                                labelText="Indirizzo*"
                                                value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress]}
                                                onValueChange={e => {
                                                    props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddress, e);
                                                    if (e.length === 0) {
                                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber, '');
                                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality, '');
                                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap, '');
                                                        props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince, '');
                                                    }
                                                }}
                                                error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressError]}
                                                onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressError)}
                                                ref={gasAddressRef}
                                                validator={VALIDATORS_TYPE.noValidation}
                                            />
                                        </InputWrapper>
                                        <InputWrapper>
                                            <TextInput
                                                labelText="Numero civico*"
                                                value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber]}
                                                onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumber, e)}
                                                error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumberError]}
                                                onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyAddressNumberError)}
                                                validator={VALIDATORS_TYPE.onlyNumbers}
                                            />
                                        </InputWrapper>
                                        <InputWrapper>
                                            <TextInput
                                                labelText="Comune*"
                                                value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality]}
                                                onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality, e)}
                                                error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipalityError]}
                                                onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipalityError)}
                                                options={props.provinces}
                                                onSelectOption={o => onSelectMunicipalityOption(o, MUNICIPALITY_FIELDS.gas)}
                                                optionsExtractText={o => o.comune}
                                            />
                                        </InputWrapper>
                                        <InputWrapperHalf>
                                            <TextInput
                                                labelText="CAP*"
                                                value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap]}
                                                onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap, e)}
                                                error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCapError]}
                                                onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCapError)}
                                                options={props[MUNICIPALITY_FIELDS.gas] && props[MUNICIPALITY_FIELDS.gas].cap}
                                                onSelectOption={option => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyCap, option)}
                                                optionsExtractText={o => o}
                                                validator={VALIDATORS_TYPE.onlyNumbers}
                                            />
                                        </InputWrapperHalf>
                                        <InputWrapperHalf>
                                            <TextInput
                                                labelText="PROVINCIA*"
                                                value={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince]}
                                                onValueChange={e => props.onChangeText(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvince, e)}
                                                error={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvinceError]}
                                                onFocus={() => props.resetError(SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyProvinceError)}
                                                editable={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality] && props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.gasSupplyMunicipality].length > 0}
                                            />
                                        </InputWrapperHalf>
                                    </section>
                                </FormContainer>
                            </React.Fragment>
                        }

                        <SubmitButton
                            mainColor={THEME_COLORS.blueViolet}
                            type="submit"
                            value="Prosegui"
                            disabled={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.isSubmittingForm]}
                            onClick={async e => {
                                //leggo il cookie di commanders act e lo aggiungo a tC.eventConfirmStep
                                let VivigasUIdCookie = document.cookie.replace(/(?:(?:^|.*;\s*)VivigasUId\s*\=\s*([^;]*).*$)|^.*$/, "$1");
                                //alert(cookieValue);
                                e.preventDefault();
                                try {
                                    await props.validate();
                                    window.tC.event.confirmStep(this, {stepId: 'funnel_step3', user_id : `"${VivigasUIdCookie}"`})
                                    console.log('tCEvent-> confirmStep funnel_step3')
                                    props.history.push('/recapito-pagamento');
                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                            errorText={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.errorFormSubmission]}
                            onClickSaveAndContinueLater={async e => {
                                e.preventDefault();
                                try {
                                    await props.validate(false);
                                    window.tC.event.dropOffConDatiSaveAndResume();
                                    console.log('tCEvent-> dropOffConDatiSaveAndResume funnel_step3')
                                } catch (error) {
                                    console.log(error);
                                }
                            }}
                            successText={props.form[SUPPLY_ADDRESS_FORM_FIELD_NAMES.successText]}
                        />
                        <AccordionContainer>
                            <Accordion />
                        </AccordionContainer>
                    </div>
                    <div className=".d-xs-none .d-sm-none .d-md-none .d-lg-none col-xl-3">
                        <OfferBox {...props.offer} />
                    </div>
                </div>
            </div>
            <BottomSheet
                TriggerContent={
                    <BottomsheetTriggerContainer>
                        <div style={{ marginRight: '20px' }}>
                            <BottomsheetTriggerTitle>{props.offer.name}</BottomsheetTriggerTitle>
                            <BottomsheetTriggerSubTitle>VISUALIZZA I DETTAGLI</BottomsheetTriggerSubTitle>
                        </div>
                    </BottomsheetTriggerContainer>
                }
                HeaderContent={<BottomSheetHeaderText>CHIUDI I DETTAGLI</BottomSheetHeaderText>}
                backgroundColor="white"
                Content={<Offer {...props.offer} isMobile={true} />}
                maxExcludedScreenSize={MEDIA_QUERIES.desktop}
            />
        </React.Fragment>
    );
};